// extracted by mini-css-extract-plugin
module.exports = {"border":"AmountField_border__3l16c","title":"AmountField_title__1Ve6x","tooltip":"AmountField_tooltip__2v-pi","reminder":"AmountField_reminder__Tt0ke"};